export default __webpack_public_path__ + "static/media/incorrect.2fa5f3ca.svg";